import { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';

class CheckboxGroup extends Component {
  constructor(props) {
    super(props);
    const { options } = props;
    this.state = { options };
  }

   
  UNSAFE_componentWillReceiveProps(props) {
    if (props.options === null) throw new Error('options cannot be null');
    if (Array.isArray(props.options) === false) throw new Error('options must be an array');
    this.setState({ options: props.options });
  }

  handleChange = (item, value) => {
    const { onChange, behavior } = this.props;
    const { options } = this.state;
    const index = options.indexOf(item);
    const newData = [...options].map((i) =>
      behavior === 'normal' ? { ...i } : { ...i, checked: false }
    );
    newData[index] = { ...newData[index], checked: value };
    this.setState({ options: newData });
    onChange(newData, newData[index]);
  };

  render() {
    const { className } = this.props;
    const { options } = this.state;

    return (
      <div className={className}>
        {options.map((o) => (
          <Checkbox
            key={`cb_${o.value}_${o.label}`}
            onChange={(value) => {
              this.handleChange(o, value);
            }}
            checked={o.checked}
            value={o.value}
            label={o.label}
            disabled={o.disabled}
          />
        ))}
      </div>
    );
  }
}

CheckboxGroup.defaultProps = {
  className: '',
};

CheckboxGroup.propTypes = {
  options: PropTypes.arrayOf(Object).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  behavior: PropTypes.oneOf(['normal', 'radio']),
};

CheckboxGroup.defaultProps = {
  behavior: 'normal',
};

export default CheckboxGroup;
